<form class="confirm-mnemonic-form" [formGroup]="formGroup">
  <div class="text-white text-xl mt-4">
    Confirm your mnemonic
  </div>
  <div class="my-4 text-hint text-lg leading-snug">
    Enter all 24 words for your mnemonic from the previous step to proceed. Remember this is the <span class="text-error font-semibold">only way</span> you can recover your validator keys if you lose your wallet.
  </div>
  <mat-form-field appearance="outline">
    <mat-label>Confirm your mnemonic</mat-label>
    <textarea matInput
      name="mnemonic"
      formControlName="mnemonic"
      cdkTextareaAutosize
      appBlockCopyPaste
      #autosize="cdkTextareaAutosize"
      cdkAutosizeMinRows="3"
      cdkAutosizeMaxRows="4"></textarea>
      <mat-error class="warning" *ngIf="formGroup?.controls.mnemonic.hasError('required')">
        Mnemonic is required
      </mat-error>
      <mat-error class="warning" *ngIf="formGroup?.controls.mnemonic.hasError('properFormatting')">
        Must contain 24 words separated by spaces
      </mat-error>
      <mat-error class="warning" *ngIf="formGroup?.controls.mnemonic.hasError('mnemonicMismatch')">
        Entered mnemonic does not match original
      </mat-error>
  </mat-form-field>
</form>
